// Copyright 2017 Sorama B.V.

import { HttpResponseMessage } from "aurelia-http-client";

export class FileDownloader {
    public static downloadAsFileFromURL(url: string, filename: string) {
        const clickEvent = new MouseEvent("click", { view: window, bubbles: false, cancelable: false });

        const element = document.createElement("a");
        element.setAttribute("href", url);
        element.setAttribute("download", filename);
        element.dispatchEvent(clickEvent);

        URL.revokeObjectURL(url);
    }

    public static async getFileDataFromURL(url: string): Promise<Blob> {
        const response = await fetch(url);
        return await response.blob();
    }

    public static downloadAsFile(content: BlobPart, mimeType: string, filename: string) {
        const blob = new Blob([content], { type: mimeType });
        const url = URL.createObjectURL(blob);

        FileDownloader.downloadAsFileFromURL(url, filename);
    }

    public static downloadBlobAsFile(blob: Blob, mimeType: string, filename: string): void {
        const clickEvent = new MouseEvent("click", { view: window, bubbles: false, cancelable: false });

        const element = document.createElement("a");
        element.setAttribute("href", URL.createObjectURL(blob));
        element.setAttribute("download", filename);
        element.dispatchEvent(clickEvent);
    }

    public static downloadAsFileFromResponse(response: HttpResponseMessage, filename?: string) {
        // get filename from response if not provided
        if (!filename) {
            if (
                !response.headers.has("Content-Disposition") ||
                !response.headers.get("Content-Disposition").includes("filename=")
            ) {
                filename = "download";
            }
            filename = response.headers.get("Content-Disposition").split("filename=")[1];
        }

        this.downloadAsFile(response.content, response.mimeType, filename);
    }
}
